// extracted by mini-css-extract-plugin
export default {"container":"StatusPill_container__bpH-8","wrapperText":"StatusPill_wrapperText__rsQZE","text":"StatusPill_text__AA3h+"};